import { render, staticRenderFns } from "./ClaimTypePicker.vue?vue&type=template&id=7e4f0670"
import script from "./ClaimTypePicker.vue?vue&type=script&lang=js"
export * from "./ClaimTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports